import Logoblu from '../logo_blu.png';
import { SBT1990,SBT1986 } from './SBT_comp.js';


export const openCPTUReport = ({ name,tipo,comm,loc,add,fad,parQC, prof, parfs,paru,paru0,parrf,park,parocr,pardr,pares,parg0, parko,
                                    parcu, parcurem, parm, parphi,  parphip, parQt, parQtn, paricn, paric, parLT, parautLT, unitup, unitdw,
                                        mlito, mtype, mname, mgam, mcu, mphi, mdr, mm  }) => {
  // Crea i dati ordinati prima di passarli
  const combinedData = prof.map((p, index) => ({
    prof: p,
    qc: parQC[index],
    fs: parfs[index],
    u: paru[index],
    u0: paru0[index],
    rf: parrf[index],
    k: park[index],
    ocr: parocr[index],
    dr: pardr[index],
    res: pares[index],
    g0: parg0[index],
    ko: parko[index],
    cu: parcu[index],
    curem: parcurem[index],
    m: parm[index],
    phi: parphi[index],
    phip: parphip[index],
    qt: parQt[index],
    qtn: parQtn[index],
    icn: paricn[index],
    ic: paric[index],
    lt: parLT[index],
  })).sort((a, b) => b.prof - a.prof);

  const profSorted = combinedData.map(d => d.prof);
  const qcSorted = combinedData.map(d => d.qc);
  const fsSorted = combinedData.map(d => d.fs);
  const uSorted = combinedData.map(d => d.u);
  const u0Sorted = combinedData.map(d => d.u0);
  const rfSorted = combinedData.map(d => d.rf);
  const kSorted = combinedData.map(d => d.k);
  const ocrSorted = combinedData.map(d => d.ocr);
  const drSorted = combinedData.map(d => d.dr);
  const resSorted = combinedData.map(d => d.res);
  const g0Sorted = combinedData.map(d => d.g0);
  const koSorted = combinedData.map(d => d.ko);
  const cuSorted = combinedData.map(d => d.cu);
  const curemSorted = combinedData.map(d => d.curem);
  const mSorted = combinedData.map(d => d.m);
  const phiSorted = combinedData.map(d => d.phi);
  const phipSorted = combinedData.map(d => d.phip);
  const qtSorted = combinedData.map(d => d.qt);
  const qtnSorted = combinedData.map(d => d.qtn);
  const icnSorted = combinedData.map(d => d.icn);
  const icSorted = combinedData.map(d => d.ic);
  const ltSorted = combinedData.map(d => d.lt);
   // stratigrafia
  const unitupSorted = unitup?.length ? [...unitup].reverse().map(Number) : [];
  const unitdwSorted = unitdw?.length ? [...unitdw].reverse().map(Number) : [];
  const mlitoSorted = mlito?.length ? [...mlito].reverse() : [];
  const mgamSorted = mgam?.length ? [...mgam].reverse() : [];
  const mcuSorted = mcu?.length ? [...mcu].reverse() : [];
  const mphiSorted = mphi?.length ? [...mphi].reverse() : [];
  const mdrSorted = mdr?.length ? [...mdr].reverse() : [];
  const mmSorted = mm?.length ? [...mm].reverse() : [];
  const mtypeSorted = mtype?.length ? [...mtype].reverse() : [];
  const mnameSorted = mname?.length ? [...mname].reverse() : [];

  const tipologiaVal = tipo;
  const nomeProvaVal = name;
  const committenteVal = comm;
  const luogoVal = loc;
  const indirizzoVal = add;
  const faldaVal = fad;
  const autLTVal = parautLT;

  const maxProf = Math.max(...profSorted);
  const minProf = Math.min(...profSorted);

  // Data e ora odierna
  const now = new Date();
  const dateStr = now.toLocaleDateString('it-IT');
  const timeStr = now.toLocaleTimeString('it-IT');

  // Apriamo una nuova finestra per il report
  const reportWindow = window.open('', '_blank', 'width=1200,height=750');
  const SBTdata = JSON.stringify(SBT1990);
  const SBTdata1986 = JSON.stringify(SBT1986);

  const stratigraphyRows = unitupSorted
      .map((top, i) => ({
        top: Number(top),
        bottom: Number(unitdwSorted[i]),
        name: mnameSorted[i],
        type: mtypeSorted[i],
        gam: Number(mgamSorted[i]),
        cu: Number(mcuSorted[i]),
        phi: Number(mphiSorted[i]),
        dr: Number(mdrSorted[i]),
        m: Number(mmSorted[i])
      }))

      // elimina strati 0-0
      .filter(d => d.bottom !== 0 || d.top !== 0)

      // rimuove duplicati
      .filter((d, i, arr) =>
        arr.findIndex(s => s.top === d.top && s.bottom === d.bottom) === i
      )

      // ordina dall'alto verso il basso
      .sort((a, b) => a.top - b.top)

      // genera tabella
      .map(d => `
    <tr>
      <td>${d.name}</td>
      <td>${d.top}</td>
      <td>${d.bottom}</td>
      <td>${d.type}</td>
      <td>${d.gam.toFixed(2)}</td>
      <td>${d.cu.toFixed(2)}</td>
      <td>${d.phi.toFixed(2)}</td>
      <td>${d.dr.toFixed(2)}</td>
      <td>${d.m.toFixed(2)}</td>
    </tr>
    `).join("");

  let paginaLitotecnica = '';
    if (mlitoSorted.length > 1) {
      paginaLitotecnica = `
      <!-- PAGINA 7 - Verticale -->
      <div class="page1">
        <div class="title-left">
            <h2>Valori medi unità litotecniche ${nomeProvaVal}</h2>
            <hr>
        </div>
        <table class="data-table small-table" style="margin-top: 40px; margin-bottom: 20px;">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Tetto (m da p.c.)</th>
              <th>Letto (m da p.c.)</th>
              <th>Tipo</th>
              <th>γ (kN/m³)</th>
              <th>Cu (kPa)</th>
              <th>φ (°)</th>
              <th>Dr (%)</th>
              <th>M (MPa)</th>
            </tr>
          </thead>
          <tbody>
            ${stratigraphyRows}
          </tbody>
        </table>
        <div class="didascalia">
          Tab1 - Parametri medi per unità litotecniche
        </div>
      </div>
      `;
    }

  reportWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <script src="https://cdn.plot.ly/plotly-2.27.1.min.js"></script>
        <style>
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background: white;
          }

          /* Pulsanti a destra */
          .controls {
            position: fixed;
            top: 10px;
            right: 10px;
            z-index: 1000;
            display: flex;
            gap: 5px;
            background: rgba(255,255,255,0.9);
            padding: 5px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          .print-btn {
            background: #12455b;
            color: white;
            border: none;
            width: 32px;
            height: 32px;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .print-btn:hover {
            background: #0d3445;
          }

          /* PAGINE - senza salti automatici */
          @page {
            size: A4;
            margin: 1.5cm;
          }

          /* Pagina 1 - Verticale */
          .page1 {
            page: A4;
            min-height: 100vh;
            position: relative;
            padding: 20px;
          }

          /* Pagina 2 - Orizzontale */
          .page2 {
              page: landscape;
              size: A4 landscape;
              position: relative;
              padding: 5px 0px;
              display: flex;
              flex-direction: column;

              width: 100%;
              box-sizing: border-box; /* evita che il padding allarghi il box */
            }

          .content-wrapper {
              display: flex;
              flex-direction: column;
              flex: 1;
            }

          @page landscape {
            size: A4 landscape;
            margin: 1.5cm;
          }

          /* Logo solo prima pagina */
          .logo {
            position: absolute;
            bottom: 20px;
            right: 20px;
            width: 33px;
            height: auto;
            opacity: 0.7;
          }

          .logo img {
            width: 100%;
            height: auto;
            display: block;
          }

          /* Pagina 1 - Stili */
          .header {
            text-align: center;
            margin-bottom: 20px;
          }

          .header h1 {
            font-size: 28px;
            color: #333;
            margin-bottom: 5px;
          }

          .header h2 {
            font-size: 20px;
            color: #666;
            font-weight: normal;
          }

          .delimiter {
            text-align: right;
            font-size: 12px;
            color: #666;
            margin-bottom: 20px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
          }

          .data-table {
            width: 100%;
            border-collapse: collapse;
          }

          .data-table td {
            padding: 8px 12px;
            border: 1px solid #ddd;
          }

          .data-table td:first-child {
            font-weight: bold;
            background-color: #f5f5f5;
            width: 150px;
          }

          .data-table input {
            width: 100%;
            border: none;
            padding: 5px;
            font-size: 14px;
            background: transparent;
          }

          .data-table .readonly {
            background-color: #f9f9f9;
            color: #666;
            font-style: italic;
            padding: 5px;
          }

          /* Pagina 2 - Stili */
          .title-left {
            text-align: left;
            margin: 0 !important;
            padding-bottom: 10 !important;
          }

          .title-left h2 {
              font-size: 20px;
              color: #333;
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1.5 !important;
            }

          .title-left hr {
              width: 40%;
               margin: 2px 0 2px 0 !important;  /* Spazio minimo */
               padding: 0 !important;
              border: 1px solid #12455b;
            }

          /* Container grafici */
          .charts-container {
              margin: 0 !important;
              padding-bottom: 10 !important;
              height: auto;
              min-height: 0;
              display: flex;
              flex-wrap: wrap;
              gap: 5px;  /* Riduci gap se necessario */
              justify-content: center;  /* centra orizzontalmente */
              align-items: center;
            }

          .chart-item {
            width: calc(50% - 5px);
            height: 350px;
            background: white;
            border: 1px solid #eee;
            border-radius: 4px;
            padding: 5px;
          }

          .chart-item .plot-container {
            width: 100%;
            height: 100%;
          }

          .didascalia {
              margin: 0 !important;
              padding: 0 !important;
              line-height: 1 !important;
              font-size: 11px;
              text-align: center; /* centra il testo */
           }

          .page-number {
              font-size: 8px;
              color: #666;
            }

          @media print {
            .controls {
              display: none;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .page1, .page2 {
              box-shadow: none;
              padding: 0.5cm;
            }
            .chart-item {
              border: none;
              height: 380px;
            }
          }

          /* Titolo principale leggermente più piccolo */
            .h1bis {
              font-size: 18px; /* ridotto rispetto a h1 normale */
              margin-bottom: 0.3em;
              font-weight: bold;
            }

            /* Tabella con font più piccolo */
            .data-table.small-table {
              font-size: 12px;
              border-collapse: collapse;
              width: 100%;
            }

            /* Bordo e padding generale */
            .data-table.small-table th,
            .data-table.small-table td {
              padding: 6px 8px;
              border: 1px solid #ccc;
            }

            /* Riga intestazione grigia solo per i titoli */
            .data-table.small-table thead th {
              background-color: #e0e0e0;
              font-weight: bold;
              text-align: left;

            }
        </style>
      </head>
      <body>
        <!-- Pulsanti -->
        <div class="controls">
          <button class="print-btn" onclick="window.print()" title="Salva PDF">💾</button>
          <button class="print-btn" onclick="window.close()" title="Chiudi">✖</button>
          <button class="print-btn" onclick="resetEditableFields()" title="Reset Campi">↺</button>
        </div>

        <!-- PAGINA 1 - Verticale -->
        <div class="page1">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>

          <div class="header">
            <h1>V.E.S.</h1>
            <h2>Elaborato grafico prova penetrometrica</h2>
          </div>

          <table class="data-table">
            <tr><td>Committente</td><td><input type="text" id="committente" value="${committenteVal}"></td></tr>
            <tr><td>Località</td><td><input type="text" id="localita" value="${luogoVal}"></td></tr>
            <tr><td>Via</td><td><input type="text" id="via" value="${indirizzoVal}"></td></tr>
            <tr><td>Nome prova</td><td><input type="text" id="nome" value="${nomeProvaVal}"></td></tr>
            <tr><td>Tipo prova</td><td><div class="readonly">${tipologiaVal}</div></td></tr>
            <tr><td>Falda m da p.c.</td><td><div class="readonly">${faldaVal}</div></td></tr>
            <tr><td>Data elaborazione</td><td><div class="readonly">${dateStr}</div></td></tr>
          </table>

          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>

        <!-- PAGINA 2 - Orizzontale parametri-->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Parametri prova penetrometrica ${nomeProvaVal}</h2>
              <hr>
            </div>

            <div class="charts-container" id="chartsContainer1" >
              <!-- I grafici verranno inseriti dinamicamente -->
            </div>

            <div class="didascalia">
              Fig1 - Plot profondità-variabile della prova penetrometrica elaborata
            </div>
          </div>
        </div>

        <!-- PAGINA 3 - Orizzontale parametri -->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Parametri prova penetrometrica ${nomeProvaVal}</h2>
              <hr>
            </div>

            <div class="charts-container" id="chartsContainer2" >
              <!-- I grafici verranno inseriti dinamicamente -->
            </div>

            <div class="didascalia">
              Fig2 - Plot profondità-variabile della prova penetrometrica elaborata
            </div>
          </div>
        </div>

        <!-- PAGINA 4 - Orizzontale parametri -->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Parametri prova penetrometrica ${nomeProvaVal}</h2>
              <hr>
            </div>

            <div class="charts-container" id="chartsContainer3" >
              <!-- I grafici verranno inseriti dinamicamente -->
            </div>

            <div class="didascalia">
              Fig3 - Plot profondità-variabile della prova penetrometrica elaborata
            </div>
          </div>
        </div>

        <!-- PAGINA 5 - Orizzontale parametri -->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>SBT & SBT(n) ${nomeProvaVal}</h2>
              <hr>
            </div>

            <div class="charts-container" id="sbt"
             style="display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 600px;
                    width: 100%;">
                <!-- I grafici verranno inseriti dinamicamente -->
            </div>

            <div class="didascalia">
              Fig4 -  A sinistra plot valori qc/Pa-Rf su SBT chart, a destra plot valori Qtn-Fr su SBT(n) chart
            </div>
          </div>
        </div

        <!-- PAGINA 6 - Orizzontale parametri -->
        <div class="page2">
          <div class="content-wrapper" >
            <div class="title-left">
              <h2>Stratigrafia prova ${nomeProvaVal}</h2>
              <hr>
            </div>
            <!-- Contenitore flex orizzontale -->
            <div class="chart-legend-wrapper"
                 style="display:flex; justify-content:center; align-items:center; gap:20px; margin-bottom:25px;">
                <div id="sbt-zones-chart" style="width:120px; margin-right:70px;"></div>
                <div class="charts-container"
                     id="lt1990"
                     style="display:flex; justify-content:center; align-items:center;">
                </div>
                <!-- Condizione per ut1990 - mostrato solo se mlitoSorted ha più di 1 elemento -->
                    ${mlitoSorted.length > 1 ? `
                    <div class="charts-container"
                         id="ut1990"
                         style="display:flex; justify-content:center; align-items:center;">
                    </div>
                    ` : ''}
                <div id="lithology-legend" style="align-self:flex-start;">
                    <h1 class="h1bis">Legenda</h1>
                    <div id="legend-items"
                         style="display:flex; flex-direction:column; gap:5px;"></div>
                </div>
            </div>
            <div class="didascalia">
              ${autLTVal === 0
                ? 'Fig5 - A sinistra Indice SBT normalizzato (ICn), a destra classificazione stratigrafica da SBT chart'
                : 'AAA - A sinistra Indice SBT (IC), a destra classificazione stratigrafica da SBT chart'}
            </div>
          </div>
        </div>


        <!-- PAGINA 7 - Verticale -->
        ${paginaLitotecnica}

        <!-- PAGINA LEGGENDA - Verticale -->
        <div class="page1">
          <div class="delimiter">
            <span>V.E.S. - Virtual Earth Suite</span>
            <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
          </div>

          <div class="header">
            <h1 class="h1bis">Legenda parametri</h1>
          </div>
            <table class="data-table small-table">
              <thead>
                <tr>
                  <th>Variabile</th>
                  <th>Unità di misura</th>
                  <th>Descrizione</th>
                  <th>Tratto distintivo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>qc</td>
                  <td>[MPa]</td>
                  <td>Resistenza alla punta</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>fs</td>
                  <td>[kPa]</td>
                  <td>Resistenza laterale</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>u0</td>
                  <td>[kPa]</td>
                  <td>Pressione neutra idrostatica</td>
                  <td style="color: #6ec1ff; font-weight: bold;">––––––</td>
                </tr>
                <tr>
                  <td>u</td>
                  <td>[kPa]</td>
                  <td>Pressione acqua interstiziale</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Rf</td>
                  <td>[%]</td>
                  <td>Rapporto di attrito</td>
                  <td>––––––</td>
                </tr>
                 <tr>
                  <td>K</td>
                  <td>[m/s]</td>
                  <td>Permeabilità</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>OCR</td>
                  <td>[-]</td>
                  <td>Grado di sovraconsolidazione</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>DR</td>
                  <td>[%]</td>
                  <td>Densità Relativa</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Es</td>
                  <td>[MPa]</td>
                  <td>Modulo di young</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>G0</td>
                  <td>[MPa]</td>
                  <td>Modulo di taglio</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>K0</td>
                  <td>[-]</td>
                  <td>Coefficente di spinta a riposo</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Cu</td>
                  <td>[kPa]</td>
                  <td>Coesione non drenata</td>
                  <td>––––––</td>
                </tr>
                <tr>
                  <td>Cu-rem</td>
                  <td>[kPa]</td>
                  <td>Coesione non drenata rimaneggiata</td>
                  <td style="color: #acc2b9; font-weight: bold;">––––––</td>
                </tr>
              </tbody>
              <tr>
                  <td>M</td>
                  <td>[MPa]</td>
                  <td>Modulo Edometrico</td>
                  <td>––––––</td>
              </tr>
              <tr>
                  <td>φ</td>
                  <td>[°]</td>
                  <td>Angolo di attrito</td>
                  <td>––––––</td>
              </tr>
              <tr>
                  <td>φ&prime;</td>
                  <td>[°]</td>
                  <td>Angolo di attrito efficace</td>
                  <td>––––––</td>
              </tr>
            </table>
          <div class="logo">
            <img src="${Logoblu}" alt="Logo">
          </div>
        </div>

        <script>
          var pages = document.querySelectorAll('.page1, .page2');
          pages.forEach(function(page, index) {
            var pageNumberDiv = document.createElement('div');
            pageNumberDiv.className = 'page-number';
            pageNumberDiv.style.position = 'absolute';
            pageNumberDiv.style.bottom = '5px';
            pageNumberDiv.style.left = '10px';
            pageNumberDiv.style.fontSize = '9px';
            pageNumberDiv.style.color = '#666';
            pageNumberDiv.innerText = (index + 1) + " / " + pages.length;
            page.appendChild(pageNumberDiv);
          });

          // Data di stampa
          var dataEl = document.getElementById('dataStampa');
          if (dataEl) {
            dataEl.innerText = "${dateStr} ${timeStr}";
          }
        </script>

        <!-- NESSUN ALTRO DIVISORE - così finisce qui -->

        <script>
          const profSorted = ${JSON.stringify(profSorted)};
          const qcSorted = ${JSON.stringify(qcSorted)};
          const fsSorted = ${JSON.stringify(fsSorted)};
          const uSorted = ${JSON.stringify(uSorted)};
          const u0Sorted = ${JSON.stringify(u0Sorted)};
          const rfSorted = ${JSON.stringify(rfSorted)};
          const kSorted = ${JSON.stringify(kSorted)};
          const ocrSorted = ${JSON.stringify(ocrSorted)};
          const drSorted = ${JSON.stringify(drSorted)};
          const resSorted = ${JSON.stringify(resSorted)};
          const g0Sorted = ${JSON.stringify(g0Sorted)};
          const koSorted = ${JSON.stringify(koSorted)};
          const cuSorted = ${JSON.stringify(cuSorted)};
          const curemSorted = ${JSON.stringify(curemSorted)};
          const mSorted = ${JSON.stringify(mSorted)};
          const phiSorted = ${JSON.stringify(phiSorted)};
          const phipSorted = ${JSON.stringify(phipSorted)};
          const qtSorted = ${JSON.stringify(qtSorted)};
          const qtnSorted = ${JSON.stringify(qtnSorted)};
          const icnSorted = ${JSON.stringify(icnSorted)};
          const icSorted = ${JSON.stringify(icSorted)};
          const ltSorted = ${JSON.stringify(ltSorted)};
          const autLTVal = ${autLTVal};
          const pa = 0.1013252;
          const SBT1990 = ${SBTdata};
          const SBT1986 = ${SBTdata1986};

          //stratigrafia // Nuove variabili stratigrafia
          const unitupSorted = ${JSON.stringify(unitupSorted)};
          const unitdwSorted = ${JSON.stringify(unitdwSorted)};
          const mlitoSorted = ${JSON.stringify(mlitoSorted)};
          const mgamSorted = ${JSON.stringify(mgamSorted)};
          const mcuSorted = ${JSON.stringify(mcuSorted)};
          const mphiSorted = ${JSON.stringify(mphiSorted)};
          const mdrSorted = ${JSON.stringify(mdrSorted)};
          const mmSorted = ${JSON.stringify(mmSorted)};
          const mtypeSorted = ${JSON.stringify(mtypeSorted)};
          const mnameSorted = ${JSON.stringify(mnameSorted)};

          const maxProf = ${maxProf};
          const minProf = ${minProf};

          const charts1 = [
            {
              id: 'qcChart',
              data: qcSorted,
              color: 'black',
              name: 'QC',
              xLabel: 'qc [MPa]'
            },
            {
              id: 'fsChart',
              data: fsSorted,
              color: 'black',
              name: 'FS',
              xLabel: 'fs [kPa]'
            },
            {
              id: 'uChart',
              data: uSorted,
              color: 'black',
              name: 'U',
              xLabel: 'u [kPa]'
            },
            {
              id: 'frChart',
              data: rfSorted,
              color: 'black',
              name: 'RF',
              xLabel: 'Rf [%]'
            }
          ];

          const charts2 = [
            {
              id: 'kChart2',
              data: kSorted,
              color: 'black',
              name: 'k',
              xLabel: 'K [m/s]',
            },
            {
              id: 'OCRChart2',
              data: ocrSorted,
              color: 'black',
              name: 'OCR',
              xLabel: 'OCR'
            },
            {
              id: 'drChart2',
              data: drSorted,
              color: 'black',
              name: 'DR',
              xLabel: 'DR [%]'
            },
            {
              id: 'esChart2',
              data: resSorted,
              color: 'black',
              name: 'Es',
              xLabel: 'Es [MPa]'
            },
            {
              id: 'g0Chart2',
              data: g0Sorted,
              color: 'black',
              name: 'G0',
              xLabel: 'G0 [MPa]'
            }
          ];

          const charts3 = [
           {
            id: 'k0Chart3',
            data: koSorted,
            color: 'black',
            name: 'K0',
            xLabel: 'K0 [kPa]'
          },
          {
            id: 'cuChart3',
            data: cuSorted,
            color: 'black',
            name: 'Cu',
            xLabel: 'Cu [kPa]'
          },
          {
            id: 'mChart3',
            data: mSorted,
            color: 'black',
            name: 'M',
            xLabel: 'M [MPa]'
          },
          {
            id: 'phiChart3',
            data: phiSorted,
            color: 'black',
            name: "φ",
            xLabel: "φ [°]"
          },
          {
            id: 'phipChart3',
            data: phipSorted,
            color: 'black',
            name: "φ'",
            xLabel: "φ' [°]"
          },
          ];

          const CHART_WIDTH = 180;
          const CHART_HEIGHT = 570;
          // NUOVE dimensioni dedicate per SBT
          const SBT_CHART_WIDTH = 300;
          const SBT_CHART_HEIGHT = 300;
          // NUOVE dimensioni dedicate per SBT
          const LITO_CHART_WIDTH = 200;
          const LITO_CHART_HEIGHT = 520;

          window.resetEditableFields = function() {
            document.getElementById('committente').value = '';
            document.getElementById('localita').value = '';
            document.getElementById('via').value = '';
            document.getElementById('nome').value = '';
            localStorage.removeItem('cptReportData');
          };

          function loadSavedData() {
            const saved = localStorage.getItem('cptReportData');
            if (saved) {
              const data = JSON.parse(saved);
              document.getElementById('committente').value = data.committente || '';
              document.getElementById('localita').value = data.localita || '';
              document.getElementById('via').value = data.via || '';
              document.getElementById('nome').value = data.nome || '';
            }
          }

          function saveData() {
            const data = {
              committente: document.getElementById('committente').value,
              localita: document.getElementById('localita').value,
              via: document.getElementById('via').value,
              nome: document.getElementById('nome').value
            };
            localStorage.setItem('cptReportData', JSON.stringify(data));
          }

        function createCharts1() {
          const container1 = document.getElementById('chartsContainer1');
          if (!container1) return;

          container1.innerHTML = '';

          charts1.forEach((chart) => {
            const chartDiv = document.createElement('div');
            chartDiv.className = 'chart-item';
            chartDiv.style.width = CHART_WIDTH + 'px';
            chartDiv.style.height = CHART_HEIGHT + 'px';

            const plotDiv = document.createElement('div');
            plotDiv.id = chart.id;
            plotDiv.className = 'plot-container';

            chartDiv.appendChild(plotDiv);
            container1.appendChild(chartDiv);
          });

          charts1.forEach((chart) => {
            const filtered = chart.data.filter(v => v !== 0 && !isNaN(v));
                let traces = [{
                  x: chart.data.map(v => v === 0 ? null : parseFloat(v)),
                  y: profSorted,
                  type: 'scatter',
                  mode: 'lines',
                  line: { color: chart.color, width: 1.5 },
                  name: chart.name
                }];

            let allData = chart.data;
            if (chart.id === 'uChart') {
              // Filtra u0 in modo che solo valori diversi da 0 vengano considerati
              const u0Filtered = u0Sorted.map((val, i) => val !== 0 ? val : null); // null evita di plottare
              traces.push({
                x: u0Filtered.map(val => parseFloat(val)),
                y: profSorted,
                type: 'scatter',
                mode: 'lines',
                line: { color: '#6ec1ff', width: 1.5 },
                name: 'u0'
              });
              allData = [...chart.data, ...u0Filtered.filter(val => val !== null)]; // aggiorna min/max solo con valori validi
            }

            Plotly.newPlot(chart.id, traces, {
              width: CHART_WIDTH - 20,
              height: CHART_HEIGHT - 20,
              xaxis: {
                title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [Math.min(...allData) * 1.1, Math.max(...allData) * 1.1],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                autorange: false
              },
              yaxis: {
                title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [maxProf, 0],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                dtick: 1,
                autorange: false
              },
              margin: { t: 20, r: 20, l: 30, b: 30 },
              shapes: [
                {
                  type: 'line',
                  x0: Math.max(...allData) * 1.1,
                  x1: Math.max(...allData) * 1.1,
                  y0: 0,
                  y1: maxProf,
                  line: { color: 'black', width: 1 }
                }
              ],
              showlegend: false
            });
          }); // <-- chiusura forEach chart

        } // <-- chiusura createCharts1()

        function createCharts2() {
          const container2 = document.getElementById('chartsContainer2');
          if (!container2) return;

          container2.innerHTML = '';

          charts2.forEach((chart) => {
            const chartDiv = document.createElement('div');
            chartDiv.className = 'chart-item';
            chartDiv.style.width = CHART_WIDTH + 'px';
            chartDiv.style.height = CHART_HEIGHT + 'px';

            const plotDiv = document.createElement('div');
            plotDiv.id = chart.id;
            plotDiv.className = 'plot-container';

            chartDiv.appendChild(plotDiv);
            container2.appendChild(chartDiv);
          });

          charts2.forEach((chart) => {
            const filtered = chart.data.filter(v => v !== 0 && !isNaN(v));
                let traces = [{
                  x: chart.data.map(v => v === 0 ? null : parseFloat(v)),
                  y: profSorted,
                  type: 'scatter',
                  mode: 'lines',
                  line: { color: chart.color, width: 1.5 },
                  name: chart.name
                }];


            let allData = chart.data;

            // Definisco il tickformat solo per kChart2
            let xAxisFormat = {};

            if (chart.id === 'kChart2') {

              xAxisFormat = {
                title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                type: 'log',
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                exponentformat: 'power',
                autorange: true
              };

            } else {

              xAxisFormat = {
                title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [
                  Math.min(...allData) * 1.1,
                  Math.max(...allData) * 1.1
                ],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                autorange: false
              };

            }

          Plotly.newPlot(chart.id, traces, {
            width: CHART_WIDTH - 20,
            height: CHART_HEIGHT - 20,
            xaxis: xAxisFormat,
              yaxis: {
                title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [maxProf, 0],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                dtick: 1,
                autorange: false
              },
              margin: { t: 20, r: 20, l: 30, b: 30 },
              shapes: [
                {
                  type: 'line',
                  x0: Math.max(...allData) * 1.1,
                  x1: Math.max(...allData) * 1.1,
                  y0: 0,
                  y1: maxProf,
                  line: { color: 'black', width: 1 }
                }
              ],
              showlegend: false
            });
          }); // <-- chiusura forEach chart

        } // <-- chiusura createCharts2()

        function createCharts3() {
          const container3 = document.getElementById('chartsContainer3');
          if (!container3) return;

          container3.innerHTML = '';

          charts3.forEach((chart) => {
            const chartDiv = document.createElement('div');
            chartDiv.className = 'chart-item';
            chartDiv.style.width = CHART_WIDTH + 'px';
            chartDiv.style.height = CHART_HEIGHT + 'px';

            const plotDiv = document.createElement('div');
            plotDiv.id = chart.id;
            plotDiv.className = 'plot-container';

            chartDiv.appendChild(plotDiv);
            container3.appendChild(chartDiv);
          });

          charts3.forEach((chart) => {
            const filtered = chart.data.filter(v => v !== 0 && !isNaN(v));
                let traces = [{
                  x: chart.data.map(v => v === 0 ? null : parseFloat(v)),
                  y: profSorted,
                  type: 'scatter',
                  mode: 'lines',
                  line: { color: chart.color, width: 1.5 },
                  name: chart.name
                }];


            let allData = chart.data;
            if (chart.id === 'cuChart3') {
              // Filtra u0 in modo che solo valori diversi da 0 vengano considerati
              const curemFiltered = curemSorted.map((val, i) => val !== 0 ? val : null); // null evita di plottare
              traces.push({
                x: curemFiltered.map(val => val !== null ? parseFloat(val) : null),
                y: profSorted,
                type: 'scatter',
                mode: 'lines',
                line: { color: '#acc2b9', width: 1.5 },
                name: 'cu remolded'
              });
              allData = [...chart.data, ...curemFiltered.filter(val => val !== null)]; // aggiorna min/max solo con valori validi
            }

            // Calcolo min/max per asse X
            let xMin = Math.min(...allData) * 1.1;
            let xMax = Math.max(...allData) * 1.1;

            // Se è il grafico phip, forza il minimo a 15
            if (chart.id === 'phipChart3') xMin = 15;

            Plotly.newPlot(chart.id, traces, {
              width: CHART_WIDTH - 20,
              height: CHART_HEIGHT - 20,
              xaxis: {
                title: { text: chart.xLabel, font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [xMin, xMax],       // <-- qui usiamo xMin/xMax dinamici
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                autorange: false
              },
              yaxis: {
                title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 9 } },
                range: [maxProf, 0],
                showgrid: true,
                gridcolor: '#888888',
                griddash: 'dash',
                tickfont: { family: 'Roboto, sans-serif', size: 8 },
                linecolor: 'black',
                linewidth: 1,
                dtick: 1,
                autorange: false
              },
              margin: { t: 20, r: 20, l: 30, b: 30 },
              shapes: [
                {
                  type: 'line',
                  x0: Math.max(...allData) * 1.1,
                  x1: Math.max(...allData) * 1.1,
                  y0: 0,
                  y1: maxProf,
                  line: { color: 'black', width: 1 }
                }
              ],
              showlegend: false
            });
          }); // <-- chiusura forEach chart

        } // <-- chiusura createCharts2()

        function createSBTPlot(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;

            // Pulisci il container
            container.innerHTML = '';

            // Prepara i dati
            const YSBT_QT = qtSorted.map(v => v / pa);
            const YSBT_QTN = qtnSorted;
            const XSBTPLT = rfSorted.map(v => (v < 0.1 || v > 10 ? null : v));

            const YSBTPLT_QT = YSBT_QT.map(v => (v < 1 || v > 1000 ? null : v));
            const YSBTPLT_QTN = YSBT_QTN.map(v => (v < 1 || v > 1000 ? null : v));

            const zoneColors = [
                'darkblue','saddlebrown','darkolivegreen','forestgreen','goldenrod',
                'darkgoldenrod','gold','darkgrey','powderblue'
            ];

            // Funzione per trovare un punto interno al poligono
            function findPointInsidePolygon(points) {
                const validPoints = points.filter(p => p[0] > 0 && p[1] > 0);
                if (validPoints.length < 3) return null;
                const logXSum = validPoints.reduce((sum, p) => sum + Math.log10(p[0]), 0);
                const logYSum = validPoints.reduce((sum, p) => sum + Math.log10(p[1]), 0);
                const logCenterX = Math.pow(10, logXSum / validPoints.length);
                const logCenterY = Math.pow(10, logYSum / validPoints.length);
                return { x: logCenterX, y: logCenterY };
            }

            // Calcola i centri interni per ogni zona (uguali per entrambi i grafici)
            const zoneCenters = Object.keys(SBT1990).map((key, i) => {
                const center = findPointInsidePolygon(SBT1990[key]);
                if (!center) return null;
                return {
                    x: center.x,
                    y: center.y,
                    label: (i + 1).toString(),
                    zoneNum: i + 1
                };
            }).filter(z => z !== null);

            // Aggiustamenti manuali
            const manualAdjustments = {
                '1': { x: 0.2, y: 1.5 },
                '2': { x: 5, y: 1.5 },
                '7': { x: 0.2, y: 500 }
            };

            const adjustedCenters = zoneCenters.map(z => {
                if (manualAdjustments[z.zoneNum]) {
                    return { ...z, ...manualAdjustments[z.zoneNum] };
                }
                return z;
            });

            // Crea i trace per le zone (poligoni) - saranno uguali per entrambi i subplot
            const areaTraces = Object.keys(SBT1990).map((key, i) => ({
                x: SBT1990[key].map(p => p[0]),
                y: SBT1990[key].map(p => p[1]),
                type: 'scatter',
                mode: 'lines',
                line: { color: 'black' },
                fill: 'toself',
                fillcolor: zoneColors[i],
                name: key,
                opacity: 0.8,
                hoverinfo: 'none',
                xaxis: 'x',        // default primo subplot
                yaxis: 'y'         // default primo subplot
            }));

            // Trace per le zone nel secondo subplot
            const areaTraces2 = Object.keys(SBT1990).map((key, i) => ({
                x: SBT1990[key].map(p => p[0]),
                y: SBT1990[key].map(p => p[1]),
                type: 'scatter',
                mode: 'lines',
                line: { color: 'black' },
                fill: 'toself',
                fillcolor: zoneColors[i],
                name: key,
                opacity: 0.8,
                hoverinfo: 'none',
                showlegend: false,
                xaxis: 'x2',       // secondo subplot
                yaxis: 'y2'        // secondo subplot
            }));

            // Punti dati per il primo subplot (Qt/Pa)
            const pointsTrace1 = {
                x: XSBTPLT,
                y: YSBTPLT_QT,
                type: 'scatter',
                mode: 'markers',
                marker: { color: 'red', size: 5, line: { color: 'black', width: 0.5 } },
                name: 'Qt/Pa',
                hoverinfo: 'none',
                xaxis: 'x',
                yaxis: 'y'
            };

            // Punti dati per il secondo subplot (Qtn)
            const pointsTrace2 = {
                x: XSBTPLT,
                y: YSBTPLT_QTN,
                type: 'scatter',
                mode: 'markers',
                marker: { color: 'red', size: 5, line: { color: 'black', width: 0.5 } },
                name: 'Qtn',
                hoverinfo: 'none',
                xaxis: 'x2',
                yaxis: 'y2'
            };

            // Quadratini bianchi per il primo subplot
            const bgSquares1 = {
                x: adjustedCenters.map(z => z.x),
                y: adjustedCenters.map(z => z.y),
                mode: 'markers',
                type: 'scatter',
                marker: {
                    symbol: 'square',
                    size: 20,
                    color: 'white',
                    line: { color: 'black', width: 1 },
                    opacity: 0.9
                },
                hoverinfo: 'none',
                showlegend: false,
                xaxis: 'x',
                yaxis: 'y'
            };

            // Quadratini bianchi per il secondo subplot
            const bgSquares2 = {
                x: adjustedCenters.map(z => z.x),
                y: adjustedCenters.map(z => z.y),
                mode: 'markers',
                type: 'scatter',
                marker: {
                    symbol: 'square',
                    size: 20,
                    color: 'white',
                    line: { color: 'black', width: 1 },
                    opacity: 0.9
                },
                hoverinfo: 'none',
                showlegend: false,
                xaxis: 'x2',
                yaxis: 'y2'
            };

            // Numeri per il primo subplot
            const numbers1 = {
                x: adjustedCenters.map(z => z.x),
                y: adjustedCenters.map(z => z.y),
                text: adjustedCenters.map(z => z.label),
                textposition: 'middle center',
                mode: 'text',
                type: 'scatter',
                textfont: {
                    size: 12,
                    color: 'black',
                    family: 'Roboto, sans-serif',
                    weight: 'bold'
                },
                hoverinfo: 'none',
                showlegend: false,
                xaxis: 'x',
                yaxis: 'y'
            };

            // Numeri per il secondo subplot
            const numbers2 = {
                x: adjustedCenters.map(z => z.x),
                y: adjustedCenters.map(z => z.y),
                text: adjustedCenters.map(z => z.label),
                textposition: 'middle center',
                mode: 'text',
                type: 'scatter',
                textfont: {
                    size: 12,
                    color: 'black',
                    family: 'Roboto, sans-serif',
                    weight: 'bold'
                },
                hoverinfo: 'none',
                showlegend: false,
                xaxis: 'x2',
                yaxis: 'y2'
            };

            // Layout con due subplot
            const layout = {
                grid: {
                    rows: 1,
                    columns: 2,
                    pattern: 'independent',
                    roworder: 'top to bottom'
                },
                xaxis: {
                    title: {
                        text: 'Rf [%]',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    type: 'log',
                    range: [-1, Math.log10(8)],
                    tickmode: 'array',
                    tickvals: [0.1, 1, 10],
                    ticktext: ['0.1', '1', '10'],
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    showgrid: false,
                    linecolor: 'black',
                    showline: true,
                    mirror: true
                },
                yaxis: {
                    title: {
                        text: 'Qt / Pa',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    type: 'log',
                    range: [0, Math.log10(1000)],
                    tickmode: 'array',
                    tickvals: [1, 10, 100, 1000],
                    ticktext: ['1', '10', '100', '1000'],
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    showgrid: false,
                    linecolor: 'black',
                    showline: true,
                    mirror: true
                },
                xaxis2: {
                    title: {
                        text: 'Rf [%]',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    type: 'log',
                    range: [-1, Math.log10(8)],
                    tickmode: 'array',
                    tickvals: [0.1, 1, 10],
                    ticktext: ['0.1', '1', '10'],
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    showgrid: false,
                    linecolor: 'black',
                    showline: true,
                    mirror: true
                },
                yaxis2: {
                    title: {
                        text: 'Qtn',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    type: 'log',
                    range: [0, Math.log10(1000)],
                    tickmode: 'array',
                    tickvals: [1, 10, 100, 1000],
                    ticktext: ['1', '10', '100', '1000'],
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    showgrid: false,
                    linecolor: 'black',
                    showline: true,
                    mirror: true
                },
                margin: { t: 40, r: 30, l: 30, b: 40 },
                showlegend: false,
                plot_bgcolor: 'white',
                width: 900,  // Larghezza totale
                height: 450  // Altezza
            };

            const allTraces = [
                ...areaTraces, ...areaTraces2,
                pointsTrace1, pointsTrace2,
                bgSquares1, bgSquares2,
                numbers1, numbers2
            ];

            Plotly.newPlot(containerId, allTraces, layout, {
                responsive: true,
                displayModeBar: false
            });
        }

        // da rivedere questa funzione forse sbagliati limiti grafico asse y in SBT_comp

//        function createSBTPlot1986(containerId) {
//            const container = document.getElementById(containerId);
//            if (!container) return;
//
//            // Pulisci il container
//            container.innerHTML = '';
//
//            // Prepara i dati - usando SBT1986 invece di SBT1990
//            const YSBTPLT = qtSorted.map(v => (v < 1 || v > 1000 ? null : v));
//            const XSBTPLT = rfSorted.map(v => (v < 0.1 || v > 10 ? null : v));
//
//            // Colori per le zone (possiamo mantenere gli stessi o cambiarli)
//            const zoneColors = [
//                'darkblue','saddlebrown','darkolivegreen','forestgreen','limegreen','goldenrod','palegoldenrod',
//                'darkgoldenrod','gold','darkkhaki','powderblue','darkgrey'];
//
//            // Funzione per trovare un punto interno al poligono
//            function findPointInsidePolygon(points) {
//                const validPoints = points.filter(p => p[0] > 0 && p[1] > 0);
//                if (validPoints.length < 3) return null;
//                const logXSum = validPoints.reduce((sum, p) => sum + Math.log10(p[0]), 0);
//                const logYSum = validPoints.reduce((sum, p) => sum + Math.log10(p[1]), 0);
//                const logCenterX = Math.pow(10, logXSum / validPoints.length);
//                const logCenterY = Math.pow(10, logYSum / validPoints.length);
//                return { x: logCenterX, y: logCenterY };
//            }
//
//            // Calcola i centri interni per ogni zona usando SBT1986
//            const zoneCenters = Object.keys(SBT1986).map((key, i) => {
//                const center = findPointInsidePolygon(SBT1986[key]);
//                if (!center) return null;
//                return {
//                    x: center.x,
//                    y: center.y,
//                    label: (i + 1).toString(),
//                    zoneNum: i + 1
//                };
//            }).filter(z => z !== null);
//
//            // Aggiustamenti manuali (da regolare se necessario per SBT1986)
//            const manualAdjustments = {
//                '1': { x: 0.2, y: 1.5 },
//                '2': { x: 5, y: 1.5 },
//                '3': { x: 0.8, y: 8 },
//                '4': { x: 2, y: 25 },
//                '5': { x: 3, y: 45 },
//                '6': { x: 5, y: 80 },
//                '7': { x: 0.2, y: 500 },
//                '8': { x: 3, y: 250 },
//                '9': { x: 8, y: 150 }
//            };
//
//            const adjustedCenters = zoneCenters.map(z => {
//                if (manualAdjustments[z.zoneNum]) {
//                    return { ...z, ...manualAdjustments[z.zoneNum] };
//                }
//                return z;
//            });
//
//            // Trace per le zone (poligoni) con SBT1986
//            const areaTraces = Object.keys(SBT1986).map((key, i) => ({
//                x: SBT1986[key].map(p => p[0]),
//                y: SBT1986[key].map(p => p[1]),
//                type: 'scatter',
//                mode: 'lines',
//                line: { color: 'black' },
//                fill: 'toself',
//                fillcolor: zoneColors[i],
//                name: key,
//                opacity: 0.8,
//                hoverinfo: 'none'
//            }));
//
//            // Punti dati
//            const pointsTrace = {
//                x: XSBTPLT,
//                y: YSBTPLT,
//                type: 'scatter',
//                mode: 'markers',
//                marker: { color: 'red', size: 5, line: { color: 'black', width: 0.5 } },
//                name: 'SBT',
//                hoverinfo: 'none'
//            };
//
//            // Quadratini bianchi per i numeri
//            const backgroundSquaresTrace = {
//                x: adjustedCenters.map(z => z.x),
//                y: adjustedCenters.map(z => z.y),
//                mode: 'markers',
//                type: 'scatter',
//                marker: {
//                    symbol: 'square',
//                    size: 20,
//                    color: 'white',
//                    line: { color: 'black', width: 1 },
//                    opacity: 0.9
//                },
//                hoverinfo: 'none',
//                showlegend: false
//            };
//
//            // Numeri neri
//            const numbersTrace = {
//                x: adjustedCenters.map(z => z.x),
//                y: adjustedCenters.map(z => z.y),
//                text: adjustedCenters.map(z => z.label),
//                textposition: 'middle center',
//                mode: 'text',
//                type: 'scatter',
//                textfont: {
//                    size: 12,
//                    color: 'black',
//                    family: 'Roboto, sans-serif',
//                    weight: 'bold'
//                },
//                hoverinfo: 'none',
//                showlegend: false
//            };
//
//            // Layout singolo grafico
//            const layout = {
//                xaxis: {
//                    title: {
//                        text: 'Rf [%]',
//                        font: { family: 'Roboto, sans-serif', size: 10 }
//                    },
//                    type: 'log',
//                    range: [-1, Math.log10(8)],
//                    tickmode: 'array',
//                    tickvals: [0.1, 1, 10],
//                    ticktext: ['0.1', '1', '10'],
//                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
//                    showgrid: false,
//                    linecolor: 'black',
//                    showline: true,
//                    mirror: true
//                },
//                yaxis: {
//                    title: {
//                        text: 'Qt',
//                        font: { family: 'Roboto, sans-serif', size: 10 }
//                    },
//                    type: 'log',
//                    range: [0, Math.log10(1000)],
//                    tickmode: 'array',
//                    tickvals: [1, 10, 100, 1000],
//                    ticktext: ['1', '10', '100', '1000'],
//                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
//                    showgrid: false,
//                    linecolor: 'black',
//                    showline: true,
//                    mirror: true
//                },
//                margin: { t: 40, r: 40, l: 60, b: 50 },
//                showlegend: false,
//                plot_bgcolor: 'white',
//                width: 500,   // Larghezza
//                height: 500   // Altezza
//            };
//
//            const allTraces = [
//                ...areaTraces,
//                pointsTrace,
//                backgroundSquaresTrace,
//                numbersTrace
//            ];
//
//            Plotly.newPlot(containerId, allTraces, layout, {
//                responsive: true,
//                displayModeBar: false
//            });
//        }

          //Plot litologia
          //SBT1990 e 1990 normalizzata
          function createSBTLithologyPlot(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;

            container.innerHTML = '';

            const dict_plt = {
                'out of correlation': 'lightgray',
                'sensitive fine-grained': 'darkblue',
                'clay-organic soil': 'saddlebrown',
                'clay to silty clay': 'darkolivegreen',
                'clayey silt & silty clay': 'forestgreen',
                'silty sand to sandy silt': 'goldenrod',
                'clean sands to silty sands': 'darkgoldenrod',
                'dense sand to gravelly sand': 'gold',
                'stiff sand to clayey sand': 'darkgrey',
                'stiff fine-grained': 'powderblue'
            };

            const labels = Object.keys(dict_plt);

            // Prepara i dati per le tracce
            const traces = [];

            const ultimoSpessore = Math.abs(profSorted[profSorted.length - 1] - profSorted[profSorted.length - 2]);
            // Calcola il nuovo valore da aggiungere
            let nuovoValore = profSorted[profSorted.length - 1] - ultimoSpessore;
            // Se l'ultimo valore è già 0, mantieni 0 come limite superficiale
            if (profSorted[profSorted.length - 1] === 0) {
                nuovoValore = 0;
            }
            // Aggiungi il valore alla fine dell'array
            const profEsteso = [...profSorted, nuovoValore];

            for (let i = 0; i < profEsteso.length - 1; i++) {
                const top = profEsteso[i];
                const bottom = profEsteso[i + 1];
                let lt = ltSorted[i];
                let label = labels[lt];

                if (lt === 0) label = 'out of correlation';

                const color = dict_plt[label];
                let xEnd = lt;
                if (lt === 0) xEnd = 0.5;

                // Altezza del rettangolo (spessore dello strato)
                const height = Math.abs(bottom - top);

                // Centro dello strato (per posizionare la barra)
                const centerY = (top + bottom) / 2;

                traces.push({
                    type: 'bar',
                    orientation: 'h',
                    y: [centerY],
                    x: [xEnd],
                    width: [height], // Altezza della barra in unità dell'asse y
                    base: [0], // Base della barra a x=0
                    marker: {
                        color: color,
                        line: {
                            width: 0
                        }
                    },
                    hoverinfo: 'none',
                    showlegend: false,
                    xaxis: 'x',
                    yaxis: 'y'
                });
            }

            const layout = {
                width: LITO_CHART_WIDTH,
                height: LITO_CHART_HEIGHT,
                xaxis: {
                    title: {
                        text: 'SBT chart',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    range: [0, 10],
                    tickmode: "array",
                    tickvals: [...Array(10).keys()],
                    ticktext: [...Array(10).keys()],
                    showgrid: false,
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    fixedrange: true
                },
                yaxis: {
                    title: {
                        text: 'Profondità [m]',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    range: [maxProf, 0],
                    autorange: false,
                    showgrid: false,
                    linewidth: 1,
                    dtick: 1,
                    tickfont: { family: 'Roboto, sans-serif', size: 8 },
                    fixedrange: true
                },
                margin: { t: 20, l: 30, r: 30, b: 30 },
                showlegend: false,
                barmode: 'overlay', // Sovrappone le barre
                bargap: 0, // Nessun gap tra barre
                bargroupgap: 0 // Nessun gap tra gruppi
            };

            Plotly.newPlot(containerId, traces, layout, {
                responsive: true,
                displayModeBar: false,
                staticPlot: true // Disabilita interattività per rendering più pulito
            });
        }

        //plot della litologia con elaborazione unità
        function createSBTunitPlot(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;
            container.innerHTML = '';

            const dict_plt = {
                'out of correlation': 'lightgray',
                'sensitive fine-grained': 'darkblue',
                'clay-organic soil': 'saddlebrown',
                'clay to silty clay': 'darkolivegreen',
                'clayey silt & silty clay': 'forestgreen',
                'silty sand to sandy silt': 'goldenrod',
                'clean sands to silty sands': 'darkgoldenrod',
                'dense sand to gravelly sand': 'gold',
                'stiff sand to clayey sand': 'darkgrey',
                'stiff fine-grained': 'powderblue'
            };

            const labels = Object.keys(dict_plt);

            // Costruisci l’array dei confini tra strati
            const profCombined = [unitupSorted[0], ...unitdwSorted];

            // Prepara i dati per le tracce
            const traces = [];
            const annotations = [];

            for (let i = 0; i < unitupSorted.length; i++) {

                const top = Number(unitupSorted[i]);
                const bottom = Number(unitdwSorted[i]);
                const lt = Number(mlitoSorted[i]);

                let label = labels[lt];
                if (lt === 0) label = 'out of correlation';

                const color = dict_plt[label];

                const height = bottom - top;
                const centerY = top + height / 2;

                let xEnd = lt === 0 ? 0.5 : lt;
                // posizione dinamica del testo
                let testoEtichetta = mnameSorted[i];

                // Crea l'annotazione SOLO se il testo non è vuoto o undefined
                if (testoEtichetta && testoEtichetta.trim() !== '') {
                    let xEnd = lt === 0 ? 0.5 : lt;
                    // posizione dinamica del testo
                    let textX = xEnd < 1.5 ? 1 : xEnd / 2;

                    annotations.push({
                        x: textX,
                        y: centerY,
                        text: testoEtichetta,
                        showarrow: false,
                        font: { family: 'Roboto, sans-serif', size: 10, color: 'black' },
                        xanchor: 'center',
                        yanchor: 'middle',
                        bgcolor: 'white',
                        bordercolor: 'black',
                        borderwidth: 1,
                        borderpad: 2
                    });
                }

                traces.push({
                    type: 'bar',
                    orientation: 'h',
                    y: [centerY],
                    x: [xEnd],
                    width: [height],
                    base: [0],
                    marker: {
                        color: color,
                        line: { width: 0 }
                    },
                    hoverinfo: 'none',
                    showlegend: false
                });
            }

            const layout = {
                width: LITO_CHART_WIDTH,
                height: LITO_CHART_HEIGHT,
                xaxis: { title: { text: 'SBT chart', font: { family: 'Roboto, sans-serif', size: 10 } },
                         range: [0, 10], tickmode: "array", tickvals: [...Array(10).keys()],
                         ticktext: [...Array(10).keys()], showgrid: false, tickfont: { family: 'Roboto, sans-serif', size: 8 }, fixedrange: true },
                yaxis: { title: { text: 'Profondità [m]', font: { family: 'Roboto, sans-serif', size: 10 } },
                         range: [Math.max(...profCombined), 0], autorange: false, showgrid: false, linewidth: 1, dtick: 1,
                         tickfont: { family: 'Roboto, sans-serif', size: 8 }, fixedrange: true },

                annotations: annotations,
                margin: { t: 20, l: 30, r: 30, b: 30 },
                showlegend: false,
                barmode: 'overlay',
                bargap: 0,
                bargroupgap: 0
            };

            Plotly.newPlot(containerId, traces, layout, { responsive: true, displayModeBar: false, staticPlot: true });
        }

        function createLithologyLegend(containerId, dict_plt) {
            const container = document.getElementById(containerId);
            if (!container) return;
            const legendDiv = container.querySelector('#legend-items');
            if (!legendDiv) return;
            legendDiv.innerHTML = ''; // pulisci

            const labels = Object.keys(dict_plt);

            labels.forEach((label, idx) => {
                const color = dict_plt[label];

                const item = document.createElement('div');
                item.style.display = 'flex';
                item.style.alignItems = 'center';
                item.style.gap = '5px';

                // Quadratino bianco con numero
                const numberBox = document.createElement('div');
                numberBox.textContent = idx;
                numberBox.style.width = '20px';
                numberBox.style.height = '20px';
                numberBox.style.backgroundColor = 'white';
                numberBox.style.border = '1px solid black';
                numberBox.style.display = 'flex';
                numberBox.style.alignItems = 'center';
                numberBox.style.justifyContent = 'center';
                numberBox.style.fontSize = '12px';
                numberBox.style.fontWeight = 'bold';

                // Quadratino colorato della litologia usando canvas
                const colorBox = document.createElement('canvas');
                colorBox.width = 20;
                colorBox.height = 20;
                colorBox.style.border = '1px solid black';
                const ctx = colorBox.getContext('2d');
                ctx.fillStyle = color;
                ctx.fillRect(0, 0, 20, 20);

                // Testo descrittivo
                const text = document.createElement('span');
                text.textContent = label;
                text.style.fontSize = '12px';
                text.style.flex = '1'; // occupa tutto lo spazio rimanente
                text.style.whiteSpace = 'nowrap'; // evita di andare a capo
                text.style.overflow = 'hidden';
                text.style.textOverflow = 'ellipsis';

                item.appendChild(numberBox);
                item.appendChild(colorBox);
                item.appendChild(text);

                legendDiv.appendChild(item);
            });
        }

        function createSBTindex(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;
            container.innerHTML = '';

            const dict_plt = {
                2:'saddlebrown',
                3:'darkolivegreen',
                4:'forestgreen',
                5:'goldenrod',
                6:'darkgoldenrod',
                7:'gold'
            };

            const zones = [
                {id:7, x0:1,    x1:1.31},
                {id:6, x0:1.31, x1:2.05},
                {id:5, x0:2.05, x1:2.6},
                {id:4, x0:2.6,  x1:2.95},
                {id:3, x0:2.95, x1:3.6},
                {id:2, x0:3.6,  x1:4}
            ];

            const shapes = zones.map(z => ({
                type: "rect",
                x0: z.x0,
                x1: z.x1,
                y0: 0,
                y1: maxProf,
                line: {width: 0},
                fillcolor: dict_plt[z.id],
                opacity: 0.9,
                layer: 'below'
            }));

            // Determina titolo e dati in base a autLTVal
            const xAxisTitle = autLTVal === 0 ? 'ICn' : 'IC';
            const xData = autLTVal === 0 ? icnSorted : icSorted;

            // Range dell'asse x in base al tipo
            let xRange;
            if (autLTVal === 0) {
                xRange = [1, 4]; // Range per ICn
            } else {
                xRange = [1, 4]; // Stesso range per IC? Modifica se necessario
            }

            const layout = {
                width: LITO_CHART_WIDTH,
                height: LITO_CHART_HEIGHT,
                xaxis: {
                    title: {
                        text: xAxisTitle,
                        font: { family: 'Roboto, sans-serif', size: 10 },
                        standoff: 40
                    },
                    range: xRange,
                    showgrid: false,
                    tickfont: { family: 'Roboto, sans-serif', size: 8 }
                },
                yaxis: {
                    title: {
                        text: 'Profondità [m]',
                        font: { family: 'Roboto, sans-serif', size: 10 }
                    },
                    range: [maxProf, 0],
                    autorange: false,
                    showgrid: false,
                    linewidth: 1,
                    dtick: 1,
                    tickfont: { family: 'Roboto, sans-serif', size: 8 }
                },
                shapes: shapes,
                plot_bgcolor: "white",
                margin: { t: 20, l: 30, r: 30, b: 30 },
                showlegend: false
            };

            // Creiamo il trace della linea con i dati appropriati
            const lineTrace = {
                x: xData,
                y: profSorted,
                mode: 'lines',
                line: { color: 'red', width: 1.5 },
                name: 'SBT Line'
            };

            // Creiamo il grafico con il trace della linea
            Plotly.newPlot(containerId, [lineTrace], layout, {
                responsive: true,
                displayModeBar: false
            });
        }

          // Inizializzazione
          loadSavedData();
          createCharts1();
          createCharts2();
          createCharts3();
          createSBTPlot('sbt');
          //createSBTPlot1986('sbt1986');
          createSBTLithologyPlot('lt1990');
          createSBTunitPlot('ut1990');
          createLithologyLegend('lithology-legend', {
            'out of correlation':'lightgray',
            'sensitive fine-grained':'darkblue',
            'clay-organic soil':'saddlebrown',
            'clay to silty clay':'darkolivegreen',
            'clayey silt & silty clay':'forestgreen',
            'silty sand to sandy silt':'goldenrod',
            'clean sands to silty sands':'darkgoldenrod',
            'dense sand to gravelly sand':'gold',
            'stiff sand to clayey sand':'darkgrey',
            'stiff fine-grained':'powderblue'
            });
          createSBTindex('sbt-zones-chart');

          document.getElementById('committente').addEventListener('input', saveData);
          document.getElementById('localita').addEventListener('input', saveData);
          document.getElementById('via').addEventListener('input', saveData);
          document.getElementById('nome').addEventListener('input', saveData);

        </script>
      </body>
    </html>
  `);

  reportWindow.document.close();
};